import React__default from 'react';
import { H as HelpTip } from '../HelpTip/HelpTip-BXcDb080.js';
import { i as isFunction } from '../LocalModules/storm-ui-utils/dist/esm/isFunction-DjxTmSal-DjxTmSal.js';

const RenderLabelEndWithHelptip = ({
  renderLabelEnd,
  help
}) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isFunction(renderLabelEnd) && renderLabelEnd(), /*#__PURE__*/React__default.createElement(HelpTip, {
  position: "right"
}, help));

export { RenderLabelEndWithHelptip as R };
//# sourceMappingURL=RenderLabelEndWithHelptip-C16H0HDZ.js.map
